// src/utils/useAppVersion.js
// для вывода версии
import { useState, useEffect } from 'react';

export function useAppVersion() {
  const [version, setVersion] = useState('...');

  useEffect(() => {
    fetch('/version.json')
      .then(res => res.json())
      .then(data => setVersion(data.version))
      .catch(() => setVersion('unknown'));
  }, []);

  return version;
}